import { render } from "./OndemandButton.vue?vue&type=template&id=18ea3a4a&scoped=true"
import script from "./OndemandButton.vue?vue&type=script&lang=js"
export * from "./OndemandButton.vue?vue&type=script&lang=js"

import "./OndemandButton.vue?vue&type=style&index=0&id=18ea3a4a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ea3a4a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QIcon});
